import { useCallback, useEffect, useRef, useState } from 'react';

import type { ChecklistImage } from '../types/checklistImages';

export function useChecklistImages(initialImages: ChecklistImage[] = []) {
  const [images, setImagesState] = useState<ChecklistImage[]>(initialImages);

  const imagesRef = useRef(images);

  useEffect(() => {
    imagesRef.current = images;
  }, [images]);

  useEffect(() => {
    return () => {
      imagesRef.current.forEach(image => {
        if (image.file && image.previewUrl.startsWith('blob:')) {
          URL.revokeObjectURL(image.previewUrl);
        }
      });
    };
  }, []);

  const setImages = useCallback(
    (
      nextImages:
        | ChecklistImage[]
        | ((currentImages: ChecklistImage[]) => ChecklistImage[]),
    ) => {
      setImagesState(nextImages);
    },
    [],
  );

  const clearImages = useCallback(() => {
    setImagesState(currentImages => {
      currentImages.forEach(image => {
        if (image.file && image.previewUrl.startsWith('blob:')) {
          URL.revokeObjectURL(image.previewUrl);
        }
      });

      return [];
    });
  }, []);

  return {
    images,
    setImages,
    clearImages,
  };
}
